import { useState } from 'react'

export default function Roadmap() {
    const [currentStep, setCurrentStep] = useState(1)
    const handleClick = (step) => {
        setCurrentStep(step)
    }

    const timeline = [
        {
            title: 'Select Your Area',
            desc: [
                'Choose a geographic area with properties you are interested in.',
                'Ensure the area has a total population of 125,000-200,000 to have enough potential contacts.',
            ],
            imgAlt: "A graphic showing a pale blue and white map with a large orange location pin marked with the letter 'A' in the center.",
            imgTitle: 'Property search and map location graphic.',
        },
        {
            title: 'Build Your Contact List',
            desc: [
                'Pull the following lists for your designated farm area: Absentee, Equity, Trust, Vacants, Related Party, Tax Liens. (access our free resources below for more details on these lists)',
                'After pulling the above lists, you should have approximately 10,000-14,000 potential properties.',
                'Narrow down your list by identifying the properties that are on more than one list. This should get you down to 2,000-2,500 records.',
            ],
            imgAlt: 'Three diverse, smiling professionals are displayed in circular profile pictures against a gray background with concentric orange circles and dots connecting them.',
            imgTitle: 'Professional team network.',
        },
        {
            title: 'Plan Your Campaign',
            desc: [
                'Create a mailing campaign with 4-6 touches using the 2,000-2,500 high-quality properties to get maximum results.',
                'On average, most clients tend to get deals between their 3rd-4th mailer.',
            ],
            imgAlt: 'A man with a beard and a woman with glasses are smiling and collaborating, looking at a laptop screen. ',
            imgTitle: 'Two business professionals reviewing data on a laptop.',
        },
        {
            title: 'Follow Up',
            desc: [
                'Remember, over 80% of deals come from follow-up.',
                "Implement a solid follow-up system to ensure no leads are missed. Contacts who aren't ready now might be ready in the future.",
            ],
            imgAlt: 'A smiling woman in a light blue shirt and glasses is standing by a set of mailboxes, talking on a smartphone and holding a letter.',
            imgTitle: 'Woman talking on the phone after getting mail.',
        },
    ]

    return (
        <div
            id="dive-deeper"
            className="bg-gradient-to-b from-[#fdedce] via-transparent to-transparent my-16 pt-20 md:rounded-[120px] rounded-[80px]">
            <div className="container mx-auto px-8 space-y-8">
                <h3 className="font-bold text-3xl md:text-[54px] md:leading-[64px] text-center">
                    Your Direct Mail Roadmap
                </h3>
                <div>
                    <div className="flex items-center lg:justify-center mx-auto px-4 overflow-x-scroll scrollbar-hide">
                        {timeline.map((t, i) => {
                            const step = i + 1
                            return (
                                <div
                                    key={step}
                                    className="flex items-center h-24">
                                    <div className="relative">
                                        <div
                                            className={
                                                'flex items-center justify-center md:w-24 md:h-24 w-20 h-20 border border-secondary shrink-0 rounded-full cursor-pointer'
                                            }
                                            style={{
                                                backgroundColor:
                                                    currentStep === step
                                                        ? '#ed5c2f26'
                                                        : 'transparent',
                                            }}
                                            onClick={() => handleClick(step)}>
                                            <span className="md:text-xl/6 text-base/5 font-semibold text-secondary">
                                                Step {step}
                                            </span>
                                        </div>
                                    </div>
                                    {step !== timeline.length && (
                                        <div
                                            className={`w-24 h-0.5 bg-secondary ${
                                                currentStep <= step &&
                                                'opacity-20'
                                            }`}></div>
                                    )}
                                </div>
                            )
                        })}
                    </div>
                </div>
                {timeline.map((t, i) => {
                    const step = i + 1
                    return (
                        <div
                            key={i}
                            className={`md:flex-row items-center flex-col md:space-y-0 md:space-x-4 space-x-0 space-y-8 md:p-8 ${
                                currentStep === step ? 'flex' : 'hidden'
                            }`}>
                            <div className="md:w-7/12 w-full space-y-4">
                                <p className="text-secondary text-base/5 font-medium">
                                    STEP {step}
                                </p>
                                <h3 className="md:text-4xl text-4xl/tight font-bold">
                                    {t.title}
                                </h3>
                                <ul className="list-disc text-lg text-[#1e1e1e] ml-8 space-y-2">
                                    {t.desc.map((li, i) => (
                                        <li key={i}>{li}</li>
                                    ))}
                                </ul>
                            </div>
                            <div className="md:w-5/12 w-full text-center md:flex md:flex-col md:justify-center md:min-h-[465px]">
                                <img
                                    className="mx-auto"
                                    src={`/assets/get-started/roadmap/${step}.webp`}
                                    alt={t.imgAlt}
                                    title={t.imgTitle}
                                />
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
